import { ServiceGuide } from './service-guide';
import { StepHandler } from './step-handler';
import { PostalCodeValidator } from './postal-code-validator';
import { ContactFormHandler } from './contact-form-handler';

document.addEventListener('DOMContentLoaded', () => {
    const serviceGuideElement = document.querySelector('[data-component="service-guide-modal"]');

    if (serviceGuideElement) {
        try {
            const serviceGuide = new ServiceGuide(serviceGuideElement, {
                serviceOptions: window.serviceOptions,
                informationQuestionCount: window.informationQuestionCount,
                priorityOrder: window.priorityOrder,
                informationQuestions: window.informationQuestions,
                nextButtonText: window.nextButtonText,
                recommendationButtonText: window.recommendationButtonText,
                serviceoptionNotSelectedId: window.serviceoptionNotSelectedId,
                pageId: window.pageId,
            });

            if (process.env.NODE_ENV === 'development') {
                window.serviceGuide = serviceGuide;
            }
        } catch (error) {
            console.error('Failed to initialize ServiceGuide:', error);
        }
    }
});

export {
    ServiceGuide,
    StepHandler,
    PostalCodeValidator,
    ContactFormHandler,
};